module.exports = __webpack_public_path__ + "static/media/art1.a64672dc.jpg";